import { useEffect } from 'react';
import { useRoles, useUsers } from '../hooks/useUser';
import { usePlants } from '../hooks/usePlants';
import { useAppStore } from '../store/appStore';
import { tokenManager } from '../api/tokenManager';
import { useZones } from '../hooks/useZones';

const AppInit = () => {
  const { data: roles, isLoading: isRolesLoading } = useRoles();
  const { data: plants, isLoading: isPlantsLoading } = usePlants();
  const { data: zones, isLoading: isZonesLoading } = useZones();
  const { data: users, isLoading: isDashboardUserLoading } = useUsers();

  const setRoles = useAppStore((state) => state.setRoles);
  const setPlants = useAppStore((state) => state.setPlants);
  const setZones = useAppStore((state) => state.setZones);
  const setDashboardUsers = useAppStore((state) => state.setDashboardUsers);
  const setHosts = useAppStore((state) => state.setHosts);
  const setArManagers = useAppStore((state) => state.setArManagers);

  // Only fetch data if user is authenticated
  const isAuthenticated = !!tokenManager.get('accessToken');

  // useEffect(() => {
  //   const hosts = users?.filter((user:any) => user.role?.roleName === 'Meeting Manager') || [];
  //   const arManagers = users?.filter((user:any) => user.role?.roleName === 'AR Manager') || [];

  //   setHosts(hosts);
  //   setArManagers(arManagers);
  // }, [users, setHosts, setArManagers, isAuthenticated]);

  useEffect(() => {
  const safeUsers = Array.isArray(users) ? users : [];

  const hosts = safeUsers.filter(
    (user: any) => user.role?.roleName === 'Meeting Manager'
  );

  const arManagers = safeUsers.filter(
    (user: any) => user.role?.roleName === 'AR Manager'
  );

  setHosts(hosts);
  setArManagers(arManagers);
}, [users, setHosts, setArManagers, isAuthenticated]);

  useEffect(() => {
    if (roles && isAuthenticated) setRoles(roles);
  }, [roles, setRoles, isAuthenticated]);

  useEffect(() => {
    if (plants && isAuthenticated) setPlants(plants);
  }, [plants, setPlants, isAuthenticated]);

  useEffect(() => {
    if (zones && isAuthenticated) setZones(zones);
  }, [zones, setZones, isAuthenticated]);

  useEffect(() => {
    if (users && isAuthenticated) setDashboardUsers(users);
  }, [users, setDashboardUsers, isAuthenticated]);

  // Don't show loading if not authenticated
  if (!isAuthenticated) return null;

  if (isRolesLoading || isPlantsLoading || isZonesLoading || isDashboardUserLoading)
    return <div>Loading app data...</div>;

  return null;
};

export default AppInit;
